import React from 'react';
import {Link} from 'react-router-dom';

import Logo from './../../assets/images/logo.svg';

// HeaderBrand stateless component
const HeaderBrand = ({ isActive, onClick }) =>
	<div className="navbar-brand">
		<Link to={`/`} className="navbar-item">
			<img src={Logo} alt="Logo" />
		</Link>
		<p class="navbar-item">
			Jitsu Argentina
		</p>
		<div className={"navbar-burger " + (isActive ? "is-active" : "")} onClick={onClick}>
			<span></span>
			<span></span>
			<span></span>
		</div>
	</div>

export default HeaderBrand;




// WEBPACK FOOTER //
// ./src/components/Header/HeaderBrand.js